import { gql } from 'apollo-boost';
import { useMutation } from '../';

const mutation = gql`
    mutation newContributionViews($template: JSONString!, $name: String) {
      newContributionViews(template: $template, name: $name) {
        success
        id
      }
    }
`;

export function useNewContributionViews() {
  const { data, isLoading, mutate } = useMutation();
  const run = (variables, onFinish) => {
    mutate(mutation, variables, (response) => {
      if (typeof onFinish === 'function') {
        onFinish(response.newContributionViews.id);
      }
    });
  };
  return { data, isLoading, run };
}
